import MainLayout from '../../../components/Display/MainLayout';

function Home() {

  return (

    <MainLayout enableAnalytics={true} websiteLabel={"superadmin Collectif Node"}>
    </MainLayout>
  );
}

export default Home;
